import { SVGProps, Ref, forwardRef } from 'react';

export const MapPinFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M6.65 7.25c0-.48.123-.81.277-.995.117-.14.378-.355 1.073-.355s.956.215 1.073.355c.154.186.277.515.277.995s-.123.809-.277.994c-.117.14-.378.356-1.073.356s-.956-.215-1.073-.356c-.154-.185-.277-.515-.277-.994"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 .5C2.75.5 1 3.909 1 7.318c0 3.876 2.402 5.337 5.118 6.99.619.377 1.255.764 1.882 1.192a43 43 0 0 1 1.882-1.192C12.598 12.655 15 11.194 15 7.318 15 3.908 13.25.5 8 .5M5.25 7.25c0-1.375.688-2.75 2.75-2.75s2.75 1.375 2.75 2.75S10.063 10 8 10 5.25 8.625 5.25 7.25"
                fill="currentColor"
            />
        </g>
    </svg>
));
MapPinFilledSize16Glyph.displayName = 'MapPinFilledSize16Glyph';
